import clsx from 'clsx';
import { observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';
import { emptyFragment } from '../../../../EmptyFragment';
import GroupStore from '../../../../GroupStore';
import { GroupResource } from '../../../../GroupsStore/Types';
import MulticheckInput from '../../../../Multicheck/MulticheckInput';
import { MulticheckStore } from '../../../../Multicheck/Store';
import VerticalMenuIcon from '../../../Cutesies/VerticalMenuIcon';
import ModalStore from '../../../Modal/Store';
import OrganizationColumnData from '../../Columns/Organization/OrganizationColumnData';
import LastLoginAt from '../../Shared/LastLoginAt';
import ActionItems from './ActionItems';
import Actions from './ActionItems/Actions';
import Popover from './Popover';

interface Props {
  resource: GroupResource;
  modalStore: ModalStore;
  groupStore: GroupStore;
  multicheckStore: MulticheckStore<GroupResource>;
}

function Row({ resource, modalStore, groupStore, multicheckStore }: Props) {
  return (
    <tr>
      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
        <MulticheckInput
          store={multicheckStore}
          object={resource}
          id={resource.payload.id}
          ariaLabel={`Select ${resource.payload.name}`}
        />
      </td>
      <td className="whitespace-nowrap max-w-[20rem] overflow-hidden text-ellipsis py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 w-1/3">
        <NavLink to={`/people/groups/${resource.payload.id}`}>{resource.payload.name}</NavLink>
      </td>
      <OrganizationColumnData resource={resource} />
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {resource.payload.participants
          .map((participants) => (
            <Popover
              title={`${participants.length}`}
              content={
                <ul className={clsx('items-center self-stretch px-2')}>
                  {participants.map((participant) => (
                    <li key={participant.id} className={clsx('p-2')}>
                      {participant.name}
                    </li>
                  ))}
                </ul>
              }
            />
          ))
          .getOrElse(emptyFragment)}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        <LastLoginAt lastLoginAt={resource.payload.lastLoginAt} />
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {resource.payload.totalEnrollmentsCount}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {resource.payload.status}
      </td>
      <td className="whitespace-nowrap px-3 py-4">
        <ActionItems icon={<VerticalMenuIcon />} content={<Actions resource={resource} />} />
      </td>
    </tr>
  );
}

export default observer(Row);
